import axios from "axios";
import { ResponseCodes } from "./types/responseCodes";
import { Dictionary } from "./types/interfaces/dictionary";
import { eventEmitter } from "./helpers/eventEmitter";
import { REFRESH_PAGE, redirectToRefresh, redirectToSignIn } from "./helpers/authSession";

export const addAuthHeader = (header: Dictionary<string> | null = null) => {
  if (header === null) {
    header = {};
  }

  const token = localStorage.getItem("xAuthToken");
  if (token !== null) {
    header["Authorization"] = `Bearer ${token}`;
  }

  return header;
};

export const mainAPI = axios.create({
  baseURL: process.env.REACT_APP_API_MAIN_URL,
  headers: addAuthHeader(),
});

export const tripsAPI = axios.create({
  baseURL: process.env.REACT_APP_API_TRIPS_URL,
  headers: addAuthHeader(),
});

mainAPI.interceptors.response.use(
  (response) => response,
  (error) => parseErrorCode(error)
);
tripsAPI.interceptors.response.use(
  (response) => response,
  (error) => parseErrorCode(error)
);

const parseErrorCode = (error: any) => {
  if (error.response) {
    const code = error.response.status;
    const url = (error.config?.url || "").split("?")[0];
    const isRefresh = /(?:^|\/)users\/token\/refresh\/?$/.test(url);
    const isSignIn = /(?:^|\/)users\/(?:token|otp\/(?:create_otp|verify_otp))\/?$/.test(url);
    if (isRefresh && [400, 401, 403, 404].includes(code)) {
      delete mainAPI.defaults.headers.Authorization;
      delete mainAPI.defaults.headers.common.Authorization;
      delete tripsAPI.defaults.headers.Authorization;
      delete tripsAPI.defaults.headers.common.Authorization;
      redirectToSignIn();
      return Promise.reject(error.response);
    }
    const textLength = 200;
    let message = "Неизвестная ошибка";
    switch (code) {
      case ResponseCodes.UNAUTHORIZED:
        if (!isSignIn) {
          if (window.location.pathname !== REFRESH_PAGE) redirectToRefresh();
          return Promise.reject(error.response);
        }
        message = "Ошибка авторизации";
        break;
      case ResponseCodes.FORBIDDEN:
        message = "Доступ запрещен";
        break;
      case ResponseCodes.BAD_REQUEST:
        message = "Ошибка в запросе";
        break;
      default:
        console.warn(error.response);
    }
    const data = error.response.data;
    const detail = data?.detail || data?.error || data || message;
    message = typeof detail === "string" ? detail : JSON.stringify(detail);
    eventEmitter.emit("alert", {
      message: message.slice(0, textLength),
      severity: "error",
    });
  }

  return Promise.reject(error.response || error);
};
